import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/index.scss'
import './amplify-config'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />,
)
